import { ReactNode } from "react";

export function Logo({
  size = 28,
  color = "currentColor",
  accent,
}: {
  size?: number;
  color?: string;
  accent?: string;
}) {
  return (
    <span className="brand-logo" style={{ gap: size * 0.36 }}>
      <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden>
        <rect x="0.5" y="0.5" width="31" height="31" rx="9" stroke={color} strokeOpacity="0.16" />
        <path
          d="M9 22 L9 10 L22 10"
          stroke={color}
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M9 16 L17 16" stroke={color} strokeWidth="2.2" strokeLinecap="round" />
        <circle cx="22" cy="22" r="2.3" fill={accent || "var(--fv-accent)"} />
      </svg>
      <span className="brand-word" style={{ fontSize: size * 0.92, color }}>
        Fluxvia
      </span>
    </span>
  );
}

/** The nav's primary action: a link styled as the ink pill. */
export function PillLink({ href, children }: { href: string; children: ReactNode }) {
  return (
    <a href={href} className="btn btn-primary btn-md">
      {children}
    </a>
  );
}
